
import { VueGpickr, LinearGradient } from 'vue-gpickr';
import { Chrome } from 'vue-color';
import _ from 'lodash';
import Sucker from '@com/components/vue-colorpicker/Sucker';
import { exchangeLinearGradientToObject, exchangeRgbaToObject, isRGB, isRGBA } from '@com/utils/color';

var gradient = new LinearGradient({
  angle: 180,
  stops: [['#0359b5', 0], ['#f6ce01', 1]]
});

export default {
  props: {
    color: {
      type: String,
      required: true
    }
  },

  components: {
    VueGpickr: VueGpickr,
    SingleColorPicker: Chrome,
    Sucker: Sucker
  },

  data: function data() {
    return {
      activeTab: 'single',
      gradientColor: gradient,
      singleColor: '',
      currentColor: null,
      visible: false
    };
  },


  computed: {
    style: function style() {
      return {
        background: this.currentColor
      };
    },
    text: function text() {
      return this.$t('basic.colorPicker');
    },
    singleLabel: function singleLabel() {
      return this.text.single;
    },
    gradientLabel: function gradientLabel() {
      return this.text.gradient;
    },

    // 只要支持 EyeDropper API 就开启拾色功能，目前只有 Chrome 95 版本以上才支持
    dropperVisible: function dropperVisible() {
      return window.EyeDropper;
    }
  },

  watch: {
    color: function color() {
      this.init();
    },
    singleColor: function singleColor(value) {
      var _value$rgba = value.rgba,
          a = _value$rgba.a,
          b = _value$rgba.b,
          g = _value$rgba.g,
          r = _value$rgba.r;

      this.updateColor('rgba(' + r + ',' + g + ',' + b + ',' + a + ')', 'single');
    },


    gradientColor: {
      deep: true,
      handler: function handler(value) {
        var angle = value.angle,
            stops = value.stops;

        var orderedStops = _.cloneDeep(stops.slice()).sort(function (a, b) {
          return a[1] - b[1];
        });
        var color = orderedStops.map(function (c) {
          return c[0] + ' ' + Number(c[1]) * 100 + '%';
        });
        this.updateColor('linear-gradient(' + angle + 'deg, ' + color.join(',') + ')', 'gradient');
      }
    },

    visible: function visible(val) {
      if (val) {
        this.init();
      }
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    init: function init() {
      // 没有颜色时，不设置 singleColor 与 gradientColor
      if (!this.color) {
        this.activeTab = 'single';
        this.currentColor = '';
      } else if (isRGBA(this.color) || isRGB(this.color)) {
        this.activeTab = 'single';
        this.singleColor = {
          rgba: exchangeRgbaToObject(this.color)
        };
        this.currentColor = this.singleColor;
      } else {
        this.activeTab = 'gradient';
        this.currentColor = this.color;
        var obj = exchangeLinearGradientToObject(this.currentColor);
        obj && (this.gradientColor = new LinearGradient(obj));
      }
    },
    colorChange: function colorChange(value) {
      if (this.activeTab === 'single') {
        this.singleColor = { rgba: value.rgba };
      } else {
        this.$refs.gpickr.currentColor = { hex8: value.hex };
      }
    },
    selectSucker: function selectSucker(value, result) {
      if (this.activeTab === 'single') {
        this.singleColor = { rgba: value };
      } else {
        this.$refs.gpickr.currentColor = { hex8: result.sRGBHex };
      }
    },

    updateColor: _.debounce(function (color) {
      this.currentColor = color;
      console.log(this.currentColor);
      this.$emit('change', this.currentColor);
    })
  }
};